<div [formGroup]="sailorForm">
  <p-fieldset>
    <p-header class="article-title">
      <div class="article-title">Informações</div>
    </p-header>
    <div class="form-group" style="border-bottom: 4em; align-items: flex-start">
      <app-sailor-upload
      [path]="imgPreviewPhoto"
      title="Foto"
      (finishEvent)="receiveUploadUrlPhoto($event)"
      >
      </app-sailor-upload>
      &nbsp;&nbsp;&nbsp;
      <app-sailor-upload
      [path]="imgPreviewDoc"
      title="Documento"
      (finishEvent)="receiveUploadUrlDoc($event)"
      >
      </app-sailor-upload>
      &nbsp;&nbsp;&nbsp;
      <app-sailor-upload
      [path]="imgPreviewDocVerso"
      title="Documento verso"
      (finishEvent)="receiveUploadUrlDocVerso($event)"
      >
      </app-sailor-upload>
    </div>
    <br>
    <div class="form-group">
      <div class="form-control field" style="width: 33%">
        <label for="documentCountry">País emissor do documento *</label>
        <p-dropdown 
          [options]="countries" 
          formControlName="documentCountry" 
          appendTo="body"
          (onChange)="onNationalityChange()"
          placeholder="Selecione o país"
          [pTooltip]="getErrorTooltip(sailorForm.get('documentCountry'))">
        </p-dropdown>
        <small *ngIf="shouldShowError('documentCountry', 'required')" class="p-error block">
          País Obrigatório
        </small>
      </div>
      <div class="form-control field" style="width: 33%">
        <label>Tipo de Documento Fiscal *</label>
        <p-dropdown 
          [options]="federalIdTypeOptions" 
          formControlName="federalIdType" 
          placeholder="Selecione o tipo"
          (onChange)="validateFederalIdType()"
          [pTooltip]="getErrorTooltip(sailorForm.get('federalIdType'))">
        </p-dropdown>
        <small *ngIf="shouldShowError('federalIdType', 'required')" class="p-error block">
          Tipo de Documento Obrigatório
        </small>
      </div>
      <div
        class="form-control field"
        style="width: 33%"
      >
        <label for="federalId">
          <span *ngIf="isBrazilianNationality && sailorForm?.get('federalIdType')?.value === 'Physical'">{{ "FEDERAL-ID.PHYSICAL" | translate }} *</span>
          <span *ngIf="isBrazilianNationality && sailorForm?.get('federalIdType')?.value === 'Juridical'">{{ "FEDERAL-ID.JURIDICAL" | translate }} *</span>
          <span *ngIf="!isBrazilianNationality">Número do Documento *</span>
        </label>
        <p-inputMask
          *ngIf="isBrazilianNationality && sailorForm?.get('federalIdType')?.value === 'Physical'"
          type="text"
          mask="999.999.999-99"
          name="federalId"
          formControlName="federalId"
          (onBlur)="federalIdInUse(true)"
          placeholder="Digite o CPF"
          [pTooltip]="getErrorTooltip(sailorForm.get('federalId'))">
        </p-inputMask>

      <p-inputMask
          *ngIf="isBrazilianNationality && sailorForm?.get('federalIdType')?.value === 'Juridical'"
          type="text"
          mask="**.***.***/****-99"
          styleClass="uppercase-input"
          name="federalId"
          formControlName="federalId"
          (onBlur)="federalIdInUse(false)"
          placeholder="Digite o CNPJ"
          [pTooltip]="getErrorTooltip(sailorForm.get('federalId'))">
        </p-inputMask>

        <input 
          *ngIf="!isBrazilianNationality"
          pInputText 
          type="text" 
          formControlName="federalId"
          placeholder="Digite o número do documento"
          maxlength="50"
          [pTooltip]="getErrorTooltip(sailorForm.get('federalId'))">

        <div class="flex-row-between">
          <small *ngIf="shouldShowError('federalId', 'required')" class="p-error block">
            Documento Obrigatório
          </small>
          <small *ngIf="isBrazilianNationality && shouldShowError('federalId', 'invalidFederalId')" class="p-error block">
            Documento Inválido
          </small>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-control field" style="width: 33%">
        <label for="accessCategory">Categoria de Acesso *</label>
        <p-dropdown 
          [options]="accessCategoriesOptions" 
          name="dueDate" 
          formControlName="accessCategory" 
          optionLabel="name"
          appendTo="body" 
          tooltipPosition="bottom"
          [pTooltip]="getErrorTooltip(sailorForm.get('accessCategory'))">
        </p-dropdown>
        <small *ngIf="shouldShowError('accessCategory', 'required')" class="p-error block">
          Categoria de Acesso Obrigatória
        </small>
      </div>

      <div class="form-control field" style="width: 33%">
        <label for="name" style="margin-bottom: 0px; padding-bottom:0px;">
          {{ nameLabel | translate }} *
        </label>
        <input pInputText name="name" formControlName="name" maxlength="50" 
               [pTooltip]="getErrorTooltip(sailorForm.get('name'))" />
        <small *ngIf="shouldShowError('name', 'required')" class="p-error block">
          Nome Obrigatório
        </small>
      </div>

      <div class="form-control field" style="width: 33%">
        <label for="phone">{{ "CELLPHONE" | translate }}*</label>
        <div style="display: flex; gap: 8px; align-items: flex-start;">
          <p-dropdown 
            [options]="countryCodes" 
            formControlName="phoneCountry" 
            optionLabel="name" 
            [showClear]="false"
            [filter]="true" 
            filterBy="name,dialCode" 
            (onChange)="onCountrySelect($event.value)" 
            [placeholder]="'DDI'"
            [style]="{'width': '120px', 'min-width': '120px'}">
            <ng-template let-country pTemplate="item">
              <div style="display: flex; align-items: center; gap: 4px; font-size: 0.9em;">
                <span>{{ country.flag }}</span>
                <span>{{ country.dialCode }}</span>
                <span>{{ country.name }}</span>
              </div>
            </ng-template>
            <ng-template let-country pTemplate="selectedItem">
              <div style="display: flex; align-items: center; gap: 4px;">
                <span>{{ country.flag }}</span>
                <span>{{ country.dialCode }}</span>
              </div>
            </ng-template>
          </p-dropdown>

          <div style="flex: 1;">
            <input 
              pInputText 
              formControlName="phoneNumber" 
              [placeholder]="selectedCountry?.placeholder || '(11) 99999-9999'"
              (input)="applyPhoneMask($event)" 
              style="width: 100%;">
            <small 
              *ngIf="shouldShowError('phoneNumber', 'required')"
              class="p-error block">
              Telefone Obrigatório
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="readonlyForm">
      <span style="color: red;">
      Cadastro em modo de consulta. Somente vinculação de embarcações disponível. Outras alterações não serão salvas.
      </span>
    </div>
    <div class="form-group">
      <div class="form-control" style="width: 33%">
        <label for="typesSailorGroup">Tipo de Marinheiro *</label>
        <p-multiSelect
          formControlName="typesSailor"
          [defaultLabel]="'Tipo de Marinheiro'"
          appendTo="body"
          selectedItemsLabel="{0} itens selecionados"
          name="typesSailorGroup"
          [options]="permissionsOptions"
          [pTooltip]="getErrorTooltip(sailorForm.get('typesSailor'))">
        </p-multiSelect>
        <small *ngIf="shouldShowError('typesSailor', 'required')" class="p-error block">
          Tipo de Marinheiro Obrigatório
        </small>
      </div>
      <div class="form-control" style="width: 33%">
        <label for="birthday">{{ dateLabel | translate }} *</label>
        <p-calendar
          dateFormat="dd/mm/yy"
          name="birthday"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="'1950:2055'"
          rPCalendarMask
          appendTo="body"
          formControlName="birthday"
          [showIcon]="true"
          [pTooltip]="getErrorTooltip(sailorForm.get('birthday'))"
          i18n>
        </p-calendar>
        <small *ngIf="shouldShowError('birthday', 'required')" class="p-error block">
          Data Obrigatória
        </small>
        <small *ngIf="shouldShowError('birthday', 'date')" class="p-error block">
          Deve ser maior de idade
        </small>
      </div>

      <div class="form-control field" style="width: 33%">
        <label for="email">E-mail pessoal (Login app) *</label>
        <input
          pInputText
          name="email"
          formControlName="email"
          type="email"
          maxlength="50"
          id="email"
          [pTooltip]="getErrorTooltip(sailorForm.get('email'))" />
          <small *ngIf="shouldShowError('email', 'required')" class="p-error block">
            E-mail Obrigatório
          </small>
          <small *ngIf="shouldShowError('email', 'email')" class="p-error block">
            E-mail Inválido
          </small>
      </div>
    </div>
    <div class="form-group" *ngIf="!isFederalTypePhysical">
      <div class="form-control" style="width: 33%">
        <label for="countryRegistration">Inscrição municipal</label>
        <input
          pInputText
          name="countryRegistration"
          formControlName="countryRegistration"
          type="text"
          maxlength="50"
          id="countryRegistration"
        />
      </div>
    </div>
  </p-fieldset>
  <br />
  <p-fieldset>
    <p-header class="article-title">
      <div class="article-title">{{ "ADDRESS" | translate }}</div>
    </p-header>
    <app-address-temp
      [address]="sailor.residentialAddress"
      (finishEvent)="receiveAddress($event)"
    >
    </app-address-temp>
  </p-fieldset>
  <br />
  <p-fieldset>
    <p-header class="article-title">
      <div class="article-title">{{ "EMERGENCY-CONTACT" | translate }}</div>
    </p-header>
    <div class="form-group">
      <div class="form-control">
        <label for="emergencyContact">{{
          "EMERGENCY-CONTACT" | translate
        }}</label>
        <input
          pInputText
          name="emergencyContact"
          formControlName="emergencyContact"
          maxlength="50"
        />
      </div>
      <div class="form-control">
        <label for="emergencyContact">{{
          "EMERGENCY-PHONE" | translate
        }}</label>
        <p-inputMask
          type="text"
          mask="(99) 99999-9999"
          name="emergencyPhone"
          formControlName="emergencyPhone"
        >
        </p-inputMask>
      </div>
    </div>
    <div class="form-group">
      <div class="form-control" style="width: 99%">
        <label for="observation">Observações</label>
        <textarea
          pInputText
          maxlength="300"
          name="observation"
          rows="5"
          cols="90"
          formControlName="observation"
        ></textarea>
      </div>
    </div>
  </p-fieldset>
</div>
